import type { RoleRecord } from '@vlabs/api/artemy/model';
import type { BuildTableViewCellProps, TableCtx, TBuildTableViewCell } from '@vlabs/monokit/shared/ui/table-view';
import {
  buildTableViewCell,
  getTestIdFromTableCtx,
} from '@vlabs/monokit/shared/ui/table-view';

type TSharedCtx<TValue = unknown> = TableCtx<RoleRecord, TValue>;
const getRoleRowTestId = (role: RoleRecord): string | undefined => role.role_id ?? role.name;

export { renderHeader, renderCell } from '@vlabs/monokit/shared/ui/table-view';

function createRoleCell<TValue = unknown>(
  props: BuildTableViewCellProps,
): (ctx: TSharedCtx<TValue>) => TBuildTableViewCell {
  return (ctx) => buildTableViewCell({
    ...props,
    ...getTestIdFromTableCtx(ctx, getRoleRowTestId),
  });
}

export const nameCell = createRoleCell<RoleRecord['name']>({
  style: { flex: '0 0 190px', minWidth: 0 },
});

export const descriptionCell = createRoleCell<RoleRecord['description']>({
  style: { flex: '0 0 190px', minWidth: 0 },
});

export const idCell = createRoleCell<RoleRecord['role_id']>({
  style: { flex: '0 0 230px', minWidth: 0 },
});

export const createTimeCell = createRoleCell<RoleRecord['create_time']>({
  style: { flex: '0 0 190px' },
});

export const updateTimeCell = createRoleCell<RoleRecord['update_time']>({
  style: { flex: '1 1 190px', minWidth: 0 },
});

export const actionCell = createRoleCell<NonNullable<RoleRecord['role_id']>>({
  style: {
    flex: '0 0 40px',
    padding: 0,
  },
});

export const dividerCell = buildTableViewCell({
  style: {
    flex: '0 0 16px',
    padding: 0,
  },
});
